<template>
    <div class="sidebar-items-wrapper">
      <div class="flex flex-col justify-between">
        <ul class="sidenav-items overflow-y-auto" style="height: calc(100vh - 10rem)">
          <sidebar-item title="Dashboard" url="/enterprise/dashboard">
            <template v-slot:icon>
              <home-svg />
            </template>
          </sidebar-item>
          <sidebar-item title="Locations" url="/customer/locations">
            <template v-slot:icon>
              <LocationLogo />
            </template>
          </sidebar-item>
          <sidebar-item title="Users" url="/user/locations">
            <template v-slot:icon>
                <AudienceLogo />
            </template>
          </sidebar-item>

          <sidebar-item title="Carriers" url="/user/locations">
            <template v-slot:icon>
                <CarrierLogo />
            </template>
          </sidebar-item>
          <sidebar-item-dropdown title="Booking & Shipments">
            <template v-slot:icon>
              <EnterpriseBookingIcon />
            </template>
            <template v-slot:children>
              <router-link
                class="flex items-center"
                :to="{ name: 'ActiveBookings' }"
              >
              <DropDownLink title="Active Bookings">
                <img src="./svgs/enterprise_active_booking.svg" />
            </DropDownLink>
                </router-link
              >
  
              <router-link
                class="flex items-center"
                :to="{ name: 'QuoteAndDraft' }"
              >
              <DropDownLink title="Quotes & Drafts">
                <img src="@/assets/images/ondemand/quotes-draft.svg" />
              </DropDownLink>
                </router-link
              >
              <!-- <router-link :to="{ name: 'BookingHome3pl' }"
              >Shipping (Admin)</router-link
            > -->
              <router-link
                class="flex items-center"
                :to="{ name: 'HistoricalBookings' }"
                >
                <DropDownLink title=" Shipping History">
                  <img src="@/assets/images/ondemand/shippin-history.svg" />
                </DropDownLink>
               </router-link
              >
            </template>
          </sidebar-item-dropdown>
          <sidebar-item-dropdown title="Billings & Payments">
            <template v-slot:icon>
              <payments-svg />
            </template>
            <template v-slot:children>
              <router-link
                class="flex items-center"
                :to="{ name: 'PaymentsCustomerTransaction' }"
              >
              <DropDownLink title="My Transactions">
                  <img src="@/assets/images/ondemand/transactions.svg" />
              </DropDownLink>
                </router-link
              >
  
              <router-link
                v-if="$store.state.authentication.env == 'development'"
                class="flex items-center"
                :to="{ name: 'AccountStatement', params: { name: 'account' } }"
              >
              <DropDownLink title=" Account Statements">
                <img src="@/assets/images/ondemand/acount-statement.svg" />
            </DropDownLink>
             </router-link
                >
                <router-link
                class="flex items-center"
                :to="{ name: 'PaymentsTransaction' }"
                >
                <DropDownLink title="Refunds">
                    <img src="./svgs/enterprise_refund.svg" />
                </DropDownLink>
                </router-link
                >
            </template>
          </sidebar-item-dropdown>
        </ul>
        <ul class="justify-self-end">
          <div
            class="flex items-center pl-8 cursor-pointer logout"
            @click="logout"
          >
            <div class="mr-3 flex items-center">
              <span class="sidebar-item__icon inline-block">
                <img src="@/assets/images/icons/logout.svg" alt="logout icon" />
              </span>
            </div>
            <div class="text-white"
            :class="[ isSideNavCollapsed ? 'hidden' : 'inline-block']"
            >
              <p class="text-sm">Logout</p>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  import SidebarItem from "./SidebarItem";
  import SidebarItemDropdown from "./SidebarItemDropdown";
  import DropDownLink from "./DropDownLink.vue";
  import HomeSvg from "./svgs/HomeSvg";
  import PaymentsSvg from "./svgs/PaymentsSvg";
  import EnterpriseBookingIcon from "./svgs/EnterpriceBookingIcon.vue"
  import AudienceLogo from "./svgs/AudienceLogo.vue";
  import CarrierLogo from './svgs/CarrierLogo.vue'
  import LocationLogo from "./svgs/LocationIcon.vue"
  
  export default {
    components: {
      SidebarItem,
      SidebarItemDropdown,
      // MuleexLogo,
      DropDownLink,
      HomeSvg,
      PaymentsSvg,
      EnterpriseBookingIcon,
      AudienceLogo,
      CarrierLogo,
      LocationLogo
    },
    data() {
      return {
        showTerminalChildren: false,
      };
    },
    computed: {
      disabled() {
        return this.$store.state.authentication.env == "staging" ? true : false;
      },
      isSideNavCollapsed() {
        return this.$store.getters.isSideNavCollapsed;
      },
    },
    methods: {
      async logout() {
        try {
          // await this.$_logout();
          localStorage.clear();
          // localStorage.clear();
          this.$router.push({ name: "Login" });
        } catch (error) {
          this.handleError(error);
        }
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .sidenav-items {
    margin-top: 3rem;
  }
  
  .muleex-logo {
    padding-top: 1.5rem;
    padding-left: 3rem;
  }
  svg {
    display: inline-block;
  }
  </style>
  